import { createRouter } from '@tanstack/react-router';

import { routeTree } from '@/routeTree.gen';

import type { RouterContext } from './router-context';

export function createAppRouter(context: RouterContext) {
  return createRouter({
    routeTree,
    context,
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
    // Só troca de tela anima (`page`, MOVIMENTO.md). Mudar a query (`?edit=`, `?size=`, `?tab=`) não:
    // o retrato da página em transição pinta por cima dos overlays e a sheet nasceria atrás da tabela.
    defaultViewTransition: { types: ({ pathChanged }) => (pathChanged ? ['page'] : false) },
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
